<template>
  <div>
    <!-- HERO -->
    <div class="hero">
      <!-- <v-img
      :src="isSPSize
        ? require('../../assets/images/img-sp-top-main.png')
        : require('../../assets/images/img-top-main.png')"
      contain/>
      <hgroup class="hero-text">
        <h1 class="primary--text font-weight-bold ff-qs" :class="isSPSize ? 'fz30' : 'fz60'">
          Let’s paike out!

        </h1>
        <h2 class="font-weight-bold" :class="isSPSize ? 'font-h2-sp' : 'font-h1-sp'">
          Experience the world.<br>
          Make new friends.
        </h2>
      </hgroup> -->
      <video preload="metadata" autoplay loop muted playsinline>
        <source src="/thumbnails/promo.mp4" type="video/mp4" />
      </video>
    </div>

    <!-- Action Buttons -->
    <v-container class="action-buttons ma-0">
      <v-row justify="center">
        <!--
        <v-col cols="12" sm="3">
          <v-btn
            dark
            block
            rounded
            depressed
            outlined
            :height="isSPSize ? 52 : 68"
            class="primary--text"
            @click="goToTraveler"
          >
            <div class="d-flex flex-column">
              <span class="fz18 font-weight-bold">for travelers</span>
            </div>
          </v-btn>
        </v-col>
        <v-col cols="12" sm="3">
          <v-btn
            light
            block
            rounded
            depressed
            outlined
            :height="isSPSize ? 52 : 68"
            class="primary--text"
            @click="goToLocal"
          >
            <div class="d-flex flex-column">
              <span class="fz18 font-weight-bold">for locals</span>
            </div>
          </v-btn>
        </v-col>
        -->
        <v-col cols="12" sm="6" md="3" class="text-center fz17 mb-4">
          <span class="font-weight-bold d-block mb-6">Let's get started with app!</span>
          <v-row class="d-flex align-center justify-center mb-4">
              <a class="apple" href="https://apps.apple.com/app/paike-passion-like/id1539421003">
                <img class="d-block" src="@/assets/images/Download_on_the_App_Store_Badge.svg" alt="">
              </a>
              <a class="google" href="https://play.google.com/store/apps/details?id=com.paikeout.app">
                <img class="d-block" src="@/assets/images/google-play-badge.png" alt="">
              </a>
          </v-row>
          <span class="fz17">or</span>
          <v-btn
            block
            depressed
            color="primary"
            height="40"
            style="text-transform:none !important"
            class="font-weight-bold btn mt-4 py-2"
            @click="goToBoth"
          >
            Sign Up
          </v-btn>
        </v-col>
      </v-row>
      <v-row justify="center" class="pb-0">
        <v-col cols="12">
          <p class="font-xs text-center mb-0">Under the current version, limited features and areas for Paikeout are available.</p>
        </v-col>
      </v-row>
    </v-container>

    <v-container :class="isSPSize ? 'sp' : ''">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="font-h1-pc" :class="isSPSize ? 'mb30' : 'mb40'">
            What is Paike?
          </h2>
          <p>
            Paike (pronounced “pike”) was born by combining “Passion”×“Like”<br>to connect travelers and locals.
          </p>
          <v-img
            :src="require('@/assets/images/img-01.png')"
            class="mt-3 mb-5 d-inline-block"
            contain
            :max-width="isSPSize ? '' : '500px'"
          ></v-img>
          <p>
            You can't travel the world right now,<br>but you can still explore your passion here until we get through this situation together.
          </p>
        </v-col>
      </v-row>
    </v-container>

    <v-container :class="isSPSize ? 'sp' : ''" class="features">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="font-h1-pc" :class="isSPSize ? 'mb30' : 'mb40'">
            What makes Paike Special
          </h2>
          <p>
            Find other Paikers around your future destination before your trip!
          </p>
        </v-col>
      </v-row>
      <v-row justify="center" class="text-center">
        <v-col cols="12" sm="6">
          <div class="features-group">
            <h3 class="fz18 font-weight-bold">
              Traveler
            </h3>
            <div class="features-item">
              <v-img
                :src="require('@/assets/images/img-02.png')"
                class="my-3"
                contain
                height="150"
              ></v-img>
              <h4 class="fz18">
                Dive Deeper
              </h4>
              <p class="fz15">
                Experience what locals know.<br>Explore your passion without a guidebook.
              </p>
              <v-img
                :src="require('@/assets/images/img-03.png')"
                class="my-3"
                contain
                height="150"
              ></v-img>
              <h4 class="fz18">
                Explore Your Passions
              </h4>
              <p class="fz15">
                Paike out with locals and explore the new world.
              </p>
              <v-img
                :src="require('@/assets/images/img-04.png')"
                class="my-3"
                contain
                height="150"
              ></v-img>
              <h4 class="fz18">
                Free of cost
              </h4>
              <p class="fz15">
                This is a place to meet a friend, not a tour guide.
              </p>
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="6">
          <div class="features-group">
            <h3 class="fz18 font-weight-bold">
              Local
            </h3>
            <div class="features-item">
              <v-img
                :src="require('@/assets/images/local01.png')"
                class="my-3"
                contain
                height="150"
              ></v-img>
              <h4 class="fz18">
                Fluent language skills are not required
              </h4>
              <p class="fz15">
                Your “Passion&Like" works as a mutual language<br>
                to communicate with locals.
              </p>
              <v-img
                :src="require('@/assets/images/local02.png')"
                class="my-3"
                contain
                height="150"
              ></v-img>
              <h4 class="fz18">
                Enjoy international exchange
              </h4>
              <p class="fz15">
                Make international friends through your “Passion&Like".
              </p>
              <v-img
                :src="require('@/assets/images/local03.png')"
                class="my-3"
                contain
                height="150"
              ></v-img>
              <h4 class="fz18">
                Free of cost
              </h4>
              <p class="fz15">
                This is a place to make friends who share the same “Passion&Like".
              </p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!-- Paike の使い方 -->
    <!--
    <v-container :class="isSPSize ? 'sp' : ''" class="usage">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="font-h1-pc" :class="isSPSize ? 'mb30' : 'mb40'">
            How to use Paike
          </h2>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" v-for="(usage, index) in usageList" :key="index">
          <div class="usage-item d-flex align-start">
            <div class="image align-center">
              <v-img
                :src="usage.src"
                class="my-3"
                contain
                height="80"
              ></v-img>
            </div>
            <div class="text">
              <p class="fz18 font-weight-bold" v-html="usage.title"/>
              <p class="fz15" v-html="usage.text"/>
              <p v-if="usage.notice" class="notice" v-html="usage.notice"/>
              <span class="arrow" v-if="index !== usageList.length -1">
                <v-img
                  :src="require('@/assets/images/arrow-step-down.svg')"
                  contain
                  height="23"
                ></v-img>
              </span>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    -->

    <!-- Action Buttons -->
    <v-container class="action-buttons ma-0">
      <!-- <v-row justify="center">
        <p class="ff-qs font-h1-pc primary--text font-weight-bold">Let’s paike out!</p>
      </v-row> -->
      <v-row justify="center">
        <!--
        <v-col cols="12" sm="3">
          <v-btn
            dark
            block
            rounded
            depressed
            outlined
            height="68"
            class="primary--text"
            @click="goToTraveler"
            >
            <div class="d-flex flex-column">
              <span class="fz18 font-weight-bold">for travelers</span>
            </div>
          </v-btn>
        </v-col>
        <v-col cols="12" sm="3">
          <v-btn
            light
            block
            rounded
            depressed
            outlined
            height="68"
            class="primary--text"
            @click="goToLocal"
            >
            <div class="d-flex flex-column">
              <span class="fz18 font-weight-bold">for locals</span>
            </div>
          </v-btn>
        </v-col>
        -->
        <v-col cols="12" sm="6" md="3" class="text-center fz17 mb-4">
          <span class="font-weight-bold d-block mb-6">Let's get started with app!</span>
          <v-row class="d-flex align-center justify-center mb-4">
              <a class="apple" href="https://apps.apple.com/app/paike-passion-like/id1539421003">
                <img class="d-block" src="@/assets/images/Download_on_the_App_Store_Badge.svg" alt="">
              </a>
              <a class="google" href="https://play.google.com/store/apps/details?id=com.paikeout.app">
                <img class="d-block" src="@/assets/images/google-play-badge.png" alt="">
              </a>
          </v-row>
          <span class="fz17">or</span>
          <v-btn
            block
            depressed
            color="primary"
            height="40"
            style="text-transform:none !important"
            class="font-weight-bold btn mt-4 py-2"
            @click="goToBoth"
          >
            Sign Up
          </v-btn>
        </v-col>
      </v-row>
      <v-row justify="center" class="pb-0">
        <v-col cols="12">
          <p class="font-xs text-center mb-0">Under the current version, limited features and areas for Paikeout are available.</p>
        </v-col>
      </v-row>
    </v-container>

    <!--
    <v-container :class="isSPSize ? 'sp' : ''" class="video">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="font-h1-pc" :class="isSPSize ? 'mb30' : 'mb40'">
            Paiker’s Video
          </h2>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col
          cols="12"
          sm="4"
          v-for="(video, index) in videoList"
          :key="index"
        >
          <pikers-video :video="video"/>
        </v-col>
      </v-row>
    </v-container>
    -->

    <v-container :class="isSPSize ? 'sp' : ''" class="voice">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h2 class="font-h1-pc" :class="isSPSize ? 'mb30' : 'mb40'">
            Paiker’s Voice
          </h2>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col
          cols="12"
          sm="4"
          v-for="(voice, index) in voiceList"
          :key="index"
        >
          <pikers-voice :voice="voice"/>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import PikersVoice from '@/components/PikersVoice'

export default {
  components: {
    PikersVoice,
  },
  computed: {
    h1Style() {
      return this.isSPSize
        ? 'font-h1-sp font-weight-bold mb-3'
        : 'font-h1-pc font-weight-bold mb-5'
    },
    isSPSize() {
      return this.$vuetify.breakpoint.name === 'xs'
    },
  },
  data: () => ({
    usageList: [
    {
        src: require('../../assets/images/img-register.png'),
        title: '1.Register',
        text: 'Sign up with your email and let us know your “Passion&Like”.'
      },
      {
        src: require('../../assets/images/matching.png'),
        title: '2.Matching',
        text: 'We match with locals with the same “Passion&Like”.',
        notice: 'Paike searches for the best friends.'
      },
      {
        src: require('../../assets/images/pickatime.png'),
        title: '3.Pick a Time',
        text: 'Talk to the match to decide a time and location via SNS or Email.',
        notice: 'We support you until you arrange a meeting.'
      },
      {
        src: require('../../assets/images/havefun.png'),
        title: '4.Have fun',
        text: 'Meet up and enjoy! Paike out!<br>*As locals are not tour guides, they might not be fluent in English.<br>However, you can have fun together with the same “Passion&Like”.'
      },
    ],
    videoList: [
      {
        genre: 'Baseball',
        src: '<iframe width="100%" height="auto" src="https://www.youtube.com/embed/KTCzGW4cWYg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
        location: 'Mejijingu Stadium, Tokyo',
      },
      {
        genre: 'Sweets',
        src: '<iframe width="100%" height="auto" src="https://www.youtube.com/embed/qANt52x_SdM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
        location: 'Azabujuban, Tokyo',
      },
      {
        genre: 'Karaoke',
        src: '<iframe width="100%" height="auto" src="https://www.youtube.com/embed/YLwn4FQqce4" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
        location: 'Akasakamitsuke, Tokyo',
      },
    ],
    voiceList: [
      {
        title: 'Enjoyed making Okonomiyaki & Monja',
        src: require('@/assets/images/img-voice01.png'),
        like: 'Okonomiyaki',
        location: 'Tsukishima, Tokyo',
        text: 'I had a great time Paiking out with Tommy-san! As someone who loves the Japanese dish “okonomiyaki”, I was eager to try some while I was in Tokyo, but I had no idea where I could find an authentic okonomiyaki restaurant. Not only did Tommy-san bring me to a place with incredible okonomiyaki, he also introduced me to “monja”, a local specialty similar to okonomiyaki that I absolutely loved. It was so great getting to meet local people and experience a new part of Japanese cuisine that I never would have discovered on my own. I can’t wait to Paike out again on my next visit to Japan!'
      },
      {
        title: 'Karaoke',
        src: require('@/assets/images/img-voice02.png'),
        like: 'Karaoke',
        location: 'Akasakamitsuke, Tokyo',
        text: 'I always wanted to try karaoke in Japan but I didn’t have the courage to go there by myself or with my foreign friends because we didn’t know what to do. I was lucky to meet two friendly locals with Paike and we went to karaoke together and had a lot of fun! We sang different songs that we like and also songs that everyone knew such as Disney’s Frozen, hehe. I wouldn’t have had so much fun if it wasn’t for them!! Thank you, Paike!'
      },
    ]
  }),
  methods: {
    ...mapActions('storage', [
      'setLastRoute',
      'setTopButtonLocal',
      'setTopButtonTraveler',
    ]),
    goToTraveler() {
      this.setTopButtonTraveler()
      this.goTo('/onBoarding/t1')
    },
    goToLocal() {
      this.setTopButtonLocal()
      this.goTo('/onBoarding/l1')
    },
    goToBoth() {
      this.setTopButtonTraveler()
      this.goTo('/onBoarding/b1')
    },
    goTo(route) {
      this.setLastRoute('enTop')
      this.$router.push(route)
    },
  }
};
</script>

<style lang="scss" scoped>

  .apple {
    img {
      width: 100%;
      max-height: 40px;
    }
    margin-right: 6px;
  }
  .google {
    margin-left: 6px;
    img {
      height: 40px;
    }
  }
  .btn {
    font-size: $btn-font-size-smaller !important;
    letter-spacing: $btn-letter-spacing;
  }
</style>

<style lang="stylus" scoped>
@import '~@/assets/stylus/_variables'
.hero
  display block
  background #FFD5BF
  @media only screen and (min-width: 600px)
    display flex
    justify-content center
  video
    width 100%
    background #FFD5BF
    display block
    @media only screen and (min-width: 600px)
      width 600px

.action-buttons
  padding 40px 0
  background $color-lightOrange
  max-width unset !important
  @media screen and (max-width: 600px)
    padding 30px 35px
  .v-btn
    border-width 2px !important
    border-radius 8px !important
    background white

.features
  &-group
    border 2px solid $color-lightGray

    h3
      padding 20px 0
      background $color-lightOrange

.usage
  &-item
    .image
      margin-right 40px
      min-width 80px
    .text
      width 100%
      text-align left
    .notice
      background $color-lightOrange
      padding 20px

</style>